import { render, staticRenderFns } from "./AnnounceConfirm.vue?vue&type=template&id=03fb2883&scoped=true&"
import script from "./AnnounceConfirm.vue?vue&type=script&lang=js&"
export * from "./AnnounceConfirm.vue?vue&type=script&lang=js&"
import style0 from "./AnnounceConfirm.vue?vue&type=style&index=0&id=03fb2883&prod&lang=css&"
import style1 from "./AnnounceConfirm.vue?vue&type=style&index=1&id=03fb2883&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fb2883",
  null
  
)

export default component.exports